import { useContext } from "react";
import { DrawDqDataBaseStore } from "../stores/DrawDqDataBaseStore";
import { StoreContext } from "@roc/feature-app-core";

export const useDrawDqDataBaseStore = () => useContext<{
  drawDqDataBaseStore: DrawDqDataBaseStore
}>(StoreContext)